module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"views.webhooks.title":"Webhooks","views.webhooks.url":"Url","views.webhooks.lastcalled":"Last Called","views.webhooks.enabled":"Enabled"}}')
  delete Component.options._Ctor
}
